import {DatePipe} from '@angular/common';
import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {timeZonesData} from '../../config/data/time-zones/time-zones.data';
import {ICardDateAppointment} from '../../interfaces/card';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {cloneDeep} from 'lodash';
import {HelperValidationField} from '../../class/helper/helper-validation-field.class';
import {AppointmentActions, AppointmentState, AppointmentTypeEnum, IAppointment} from '../../models/appointment';
import {IPatient, PatientState} from '../../models/patient';
import {Store} from '@ngxs/store';
import {firstValueFrom, Observable} from 'rxjs';
import {Loader} from '../../models/loader/loader.redux';
import {IExpert} from '../../models/expert';
import {DateComponent} from '../date-component/date-component.component';
import {IAvailableSpot, IDateInterface, IGeneratedBlocks} from '../../interfaces/date';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {IPhoneNumber} from '../../interfaces/phone-number/phone-number.interface';
import {ScheduleAppointmentRequestDTO} from '../../dtos/service';
import {PLATFORM_CONFIG} from '../../config/platform.config';

@Component({
  selector: 'app-modal-reschedule-appointment',
  templateUrl: './modal-reschedule-appointment.component.html',
  styleUrls: ['./modal-reschedule-appointment.component.scss'],
  animations: [fadeInAnimation],
  providers: [DatePipe]
})
export class ModalRescheduleAppointmentComponent implements OnInit {
  @Input() clinicId: string;
  @Input() isVisibleModal: boolean;
  @Input() userType: 'expert' | 'patient';
  @Input() expert: IExpert;
  @Input() clinicPhones: IPhoneNumber[] = [];
  @Input() branchPhones: IPhoneNumber[] = [];
  @Input() branchEmail: string;
  @Output() closeModal: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(DateComponent) dateComponent: DateComponent;

   patient$: Observable<IPatient> = this.store.select<IPatient>(PatientState.getSelectedPatient);
   appointment$: Observable<IAppointment> = this.store.select<IAppointment>(AppointmentState.getAppointmentSelected);
   scheduleAvailability$: Observable<IGeneratedBlocks> = this.store.select<IGeneratedBlocks>(AppointmentState.getScheduleAvailability);

  appointmentTypeEnum = AppointmentTypeEnum;
  initDate: Date;
  selectedDate: Date;
  timeAppointment: Date;
  timeZone: string;
  urlSession: string;
  notesSession: string;
  itemsCardAppoinment: ICardDateAppointment[] = [];
  itemDateSelected;
  spotSelected: number;
  hourSelected: Date;
  hourSelectedEnd: Date;
  durations: any[];
  durationSelected = 30;
  stepSection = 1;
  currentStepSection = 1;
  timeZones: string[];
  helperValidationField: HelperValidationField;
  isToday: boolean;
  platformConfig = PLATFORM_CONFIG;

  constructor(
    private datePipe: DatePipe,
    private store: Store,
    public utilitiesService: UtilitiesService
  ) { }

  ngOnInit(): void {
    this.initValues();
  }

  // tslint:disable:use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges): void {
  }

  initValues(): void {
    this.helperValidationField = new HelperValidationField();
    this.initDate = new Date();
    this.itemsCardAppoinment = [
      {
        id: 'tomorrow',
        title: 'Mañana',
        dateText: this.datePipe.transform(new Date().setDate(new Date().getDate() + 1), 'dd/MM/yyyy'), // '18/12/2021'
        img: './../../../assets/images/icons/icons8-morning-100.png'
      },
      {
        id: 'week',
        title: 'Una semana',
        dateText: this.datePipe.transform(new Date().setDate(new Date().getDate() + 7), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-plus-1-week-100.png'
      },
      {
        id: '15days',
        title: 'En 15 días',
        dateText: this.datePipe.transform(new Date().setDate(new Date().getDate() + 14), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-calendar-15-100.png'
      },
      {
        id: 'month',
        title: 'Un mes',
        dateText: this.datePipe.transform(new Date().setMonth(new Date().getMonth() + 1), 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-plus-1-month-100.png'
      },
      {
        id: 'other',
        title: 'Otra fecha',
        dateText: this.datePipe.transform(this.initDate, 'dd/MM/yyyy'),
        img: './../../../assets/images/icons/icons8-date-from-100.png'
      }
    ];
    this.durations = [
      {
        id: '60',
        label: '60 MIN',
        value: 60
      },
      {
        id: '30',
        label: '30 MIN',
        value: 30
      }
    ];
    this.timeZones = timeZonesData.nameTimeZones();
    this.timeZone = this.utilitiesService.getTimeZoneBrowser();
  }

  onCloseModal(emit: boolean): void {
    this.closeModal.emit(emit);
  }

  async onSelectDate(block): Promise<void> {
    if (block.id !== this.itemDateSelected) {
      this.itemDateSelected = block.id;
      this.currentStepSection = 1;

      // Asignar fecha elegida
      if (block.id !== 'other') {
        if (block.id === 'tomorrow') {
          this.selectedDate = new Date();
          this.selectedDate.setDate(new Date().getDate() + 1);
        } else if (block.id === 'week') {
          this.selectedDate = new Date();
          this.selectedDate.setDate(new Date().getDate() + 7);
        } else if (block.id === '15days') {
          this.selectedDate = new Date();
          this.selectedDate.setDate(new Date().getDate() + 14);
        } else if (block.id === 'month') {
          this.selectedDate = new Date();
          this.selectedDate.setMonth(new Date().getMonth() + 1);
        }
        this.initDate = this.selectedDate;
        this.selectedDate.setHours(0);
        this.selectedDate.setMinutes(0);
        this.selectedDate.setSeconds(0);

        await this.getScheduleAvailable();

        // Ir al paso 2
        if (this.stepSection < 2) {
          this.goToStep(2);
        } else {
          this.checkPreviousSteps();
        }
      } else {
        if (this.initDate) {
          this.selectedDate = this.initDate;
          this.selectedDate.setHours(0);
          this.selectedDate.setMinutes(0);
          this.selectedDate.setSeconds(0);
        }

        await this.getScheduleAvailable();

        if (this.initDate && this.timeZone) {
          // Ir al paso 2
          if (this.stepSection < 2) {
            this.goToStep(2);
          } else {
            this.checkPreviousSteps();
          }
        } else {
          if (this.stepSection > 2) {
            this.checkPreviousSteps();
          }
        }
      }
    }
  }

  async onSelectDayFromDynamicSchedule(): Promise<void> {
    this.currentStepSection = 1;
    this.itemDateSelected = 'other';
    this.initDate = this.dateComponent.selectedDate;
    this.itemsCardAppoinment.find(item => item.id === 'other').dateText = this.datePipe.transform(this.initDate, 'dd/MM/yyyy');
    this.selectedDate = cloneDeep(this.initDate);
    this.selectedDate.setHours(0);
    this.selectedDate.setMinutes(0);
    this.selectedDate.setSeconds(0);

    await this.getScheduleAvailable();
    this.checkPreviousSteps();
  }

  async onSelectDuration(duration): Promise<void> {
    if (duration.id === this.durationSelected) return;
    // Valor numérico de la duración en minutos
    this.durationSelected = duration.value;
    this.currentStepSection = 1;
    await this.getScheduleAvailable();
    if (!this.itemDateSelected) return;
    if (this.itemDateSelected !== 'other' || (this.itemDateSelected === 'other' && this.initDate && this.timeZone)) {
      // Ir al paso 2
      if (this.stepSection < 2) {
        this.goToStep(2);
      } else {
        this.checkPreviousSteps();
      }
    }
  }

  async onSelectCustomDate(event): Promise<void> {
    this.selectedDate = event;
    this.selectedDate.setHours(0);
    this.selectedDate.setMinutes(0);
    this.selectedDate.setSeconds(0);
    this.itemsCardAppoinment.find(item => item.id === 'other').dateText = this.datePipe.transform(this.initDate, 'dd/MM/yyyy');
    this.currentStepSection = 1;

    await this.getScheduleAvailable();

    if (this.timeZone && this.durationSelected) {
      if (this.stepSection < 2) {
        this.goToStep(2);
      } else {
        this.checkPreviousSteps();
      }
    }
  }

  async onSelectTimezone(event): Promise<void> {
    this.currentStepSection = 1;

    await this.getScheduleAvailable();

    if (this.initDate && this.durationSelected) {
      if (this.stepSection < 2) {
        this.goToStep(2);
      } else {
        this.checkPreviousSteps();
      }
    }

  }

  async onSelectHour(spot: IAvailableSpot): Promise<void> {
    if (spot.available && this.spotSelected !== spot.startSystem) {
      this.spotSelected = spot.startSystem;
      this.hourSelected = new Date();
      const hour = Math.trunc(spot.startSystem / 60);
      const minutes = (spot.startSystem % 60);
      this.hourSelected.setHours(hour);
      this.hourSelected.setMinutes(minutes);
      this.hourSelectedEnd = cloneDeep(this.hourSelected);
      this.hourSelectedEnd.setMinutes(this.hourSelected.getMinutes() + this.durationSelected);

      if (this.stepSection < 3) {
        this.goToStep(3);
      } else {
        this.checkPreviousSteps();
      }
    }
  }

  goToStep(step = 1): void {
    if (this.stepSection < step) {
      this.stepSection = step;
    }
    if (this.currentStepSection < step) {
      this.currentStepSection = step;
    }
  }

  checkPreviousSteps(): void {
    if (this.stepSection > this.currentStepSection) {
      let currentStep = 1;
      for (let step = this.currentStepSection; step <= this.stepSection; step++) {
        currentStep = step;

        if (step === 1) {
          // Para experto: Item de fecha seleccionado y duración obligatoria; si item de fecha == other,
          //  asegurarse que se tenga fecha y zona horaria
          // Para paciente: Item de fecha seleccionado; si item de fecha == other, asegurarse que se tenga fecha y zona horaria
          if (this.userType === 'expert') {
            if (!this.itemDateSelected || !this.durationSelected) {
              break;
            }
            if (this.itemDateSelected === 'other' && (!this.initDate || !this.timeZone)) {
              break;
            }
          } else if (this.userType === 'patient') {
            if (!this.itemDateSelected || (this.itemDateSelected === 'other' && (!this.initDate || !this.timeZone))) {
              break;
            }
          }
        }

        if (step === 2) {
          if (this.hourSelected === null) {
            break;
          }
        }

      }

      this.currentStepSection = currentStep;
    }
  }

  resetModal(): void {
    this.currentStepSection = 1;
    this.stepSection = 1;
    this.urlSession = null;
    this.notesSession = null;
    this.itemDateSelected = null;
    this.durationSelected = 30;
    this.initDate = null;
    this.selectedDate = null;
    this.hourSelected = null;
    this.hourSelectedEnd = null;
    this.spotSelected = null;
  }

  /**
   * Get appointment value (IAppointmentSchedule structure)
   */
  getValue(): Partial<ScheduleAppointmentRequestDTO> {
    const cloneDate: any = cloneDeep(this.selectedDate);
    const date: IDateInterface = {
      year: cloneDate.getFullYear(),
      month: cloneDate.getMonth(),
      day: cloneDate.getDate(),
      hours: this.hourSelected.getHours(),
      minutes: this.hourSelected.getMinutes()
    };
    return {
      timeZoneExpertOverride: encodeURIComponent(this.timeZone),
      date,
      duration: this.durationSelected
    };
  }

  /**
   * Regresa los horarios del experto disponibles dada la fecha, hora y duración
   */
  async getScheduleAvailable(): Promise<void> {
    // Petición al servidor para devolver la disponibilidad
    if (this.selectedDate && this.durationSelected && this.expert) {
      await firstValueFrom((this.store.dispatch(new Loader(true))));
      this.spotSelected = null;
      this.hourSelected = null;
      this.hourSelectedEnd = null;
      const today = new Date();
      const date = new Date(this.selectedDate);
      if (date.getDate() !== today.getDate() || date.getMonth() !== today.getMonth() || date.getFullYear() !== today.getFullYear()) {
        // Si no es hoy
        date.setHours(0);
        date.setMinutes(0);
        this.isToday = false;
      } else {
        date.setHours(today.getHours() + 1);
        date.setMinutes(today.getMinutes());
        this.isToday = true;
      }
      date.setSeconds(0);
      await firstValueFrom(this.store.dispatch(new AppointmentActions.GetAvailableSchedules(
        this.clinicId,
        {
          year: date.getFullYear(),
          month: date.getMonth(),
          day: date.getDate(),
        },
        this.durationSelected,
        this.expert._id,
        encodeURIComponent(this.timeZone)
      )));
      await firstValueFrom((this.store.dispatch(new Loader(false))));
    }
  }

}
